/**
 * 后端接口地址
 */
export const Config = {
  /**
   * 获取导航列表(启用)
   */
  getNavList: 'GET /nav/list',
  /**
   * 获取导航详情
   */
  getNav: 'GET /nav/{id}',
  /**
   * 获取导航列表(所有(管理端))
   */
  queryNavList: 'GET /nav/query',
  /**
   * 删除导航
   */
  deleteNav: 'DELETE /nav/delete/{id}',
  /**
   * 添加导航
   */
  addNav: 'POST /nav/create',
  /**
   * 更新导航
   */
  updateNav: 'PATCH /nav/update',

  /**
   * 获取应用权限及导航数据
   */
  queryNavPermission: 'GET /nav/nav-permission'
}
